import React from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom";

import './App.css';

import Home from "../Home/Home";
import Projects from "../Projects";
import Research from "../Research/Research";


function Navbar() {
  return (
      <nav className="navbar navbar-expand navbar-default">
        <a className="navbar-brand d-none d-sm-inline name" href="/">Paola Valdivia</a>
        <a className="navbar-brand d-inline d-sm-none" href="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               className="bi bi-house-fill" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                  d="M8 3.293l6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
            <path fill-rule="evenodd"
                  d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
          </svg>
        </a>
        <div className="collapse navbar-collapse in" id="navbarSupportedContent">
          <ul className="navbar-nav w-100">
            <li className="nav-item px-1 px-sm-3 ml-md-auto  d-none d-md-inline">
              <NavLink to="/" activeClassName="active" exact={true}>ABOUT ME</NavLink>
            </li>
            <li className="nav-item ml-auto ml-md-0 px-2 px-sm-3">
              <NavLink to="/research" activeClassName="active">RESEARCH</NavLink>
            </li>
            <li className="nav-item pl-2 pl-sm-3">
              <NavLink to="/projects" activeClassName="active">PROJECTS</NavLink>
            </li>
          </ul>
        </div>
      </nav>
  );
}

export default function App() {
  return (
      <Router basename="/">
        <div className="container">
          <Navbar/>
          <Switch>
            <Route exact path="/">
              <Home/>
            </Route>
            <Route exact path="/projects">
              <Projects/>
            </Route>
            <Route exact path="/research">
              <Research/>
            </Route>
          </Switch>

          <footer>
            {/*<Contact />*/}
            paola.valdivia@inria.fr
            <br/>
            last update: Feb, 2021 &nbsp;&nbsp;&nbsp;&nbsp;
            © <a href="#about"> Paola Valdivia </a>
          </footer>
        </div>
      </Router>
  );
}



// WEBPACK FOOTER //
// ./src/App/App.js